import styled from 'styled-components';

export const StyledSelect = styled('div')`
  border: 1px solid rgb(148, 148, 148);
  border-radius: 4px;
  box-sizing: border-box;
  width: 100%;
  background-color: #ffffff;

  display: flex;

  height: 36px;

  overflow: hidden;
`;

export const Flag = styled('div')`
  height: 100%;
  width: 50px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-right: 1px solid #999999;

  & img {
    height: 29px;
  }
`;

export const StyledNationalitySelect = styled('select')`
  border: 0;
  background-color: #ffffff;
  padding: 9px;
  flex-grow: 1;
`;

export const StyledNationalitySelectLabel = styled('label')`
  margin: 0px 0px 8px;
  padding: 0px;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  display: block;
  color: rgb(95, 95, 95);
`;

export const Wrapper = styled('div')`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
`;
